"use strict";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import Account from "../../api/account";
import AutoConfirmedLoadHeader from "../auto_confirmed_load_header";
import InvoiceInputFieldsOwnerMixin from "./invoice_input_fields_owner_mixin";
import LoadAssignerProgress, {
  getLoadAssignerProgressItems
} from "./load_assigner_progress";
import LoadTable from "./load_table";
import LoadSearchArea from "./load_search_area";
import DocumentExceptionArea from "./document_exception_area";
import CarrierChooser from "./carrier_chooser";
import CarrierInvoiceChooser from "./carrier_invoice_chooser";
import DocumentTitle from "react-document-title";
import { History } from "react-router";
import reactUtils from "../../react_utils";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import Auth from "../../util/auth";
var bem = reactUtils.makeBem("document-group-editor");
function hasGuessedLoad(props) {
  return props.loads.guessed.length > 0 || props.loads.selected;
}
function hasInvoices(props) {
  return props.invoicesForGroup.length > 0;
}
function selectedLoadHasCustomerCustomExceptionMessages(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return ((_e = (_d = (_c = (_b = (_a = props.loads.selectedLoad) == null ? void 0 : _a.load) == null ? void 0 : _b.customer) == null ? void 0 : _c.settings["rules_broker_custom_exception_messages"]) == null ? void 0 : _d.length) != null ? _e : 0) > 0 || ((_j = (_i = (_h = (_g = (_f = props.loads.selectedLoad) == null ? void 0 : _f.load) == null ? void 0 : _g.tms_load_shipments) == null ? void 0 : _h.flatMap(
    (s) => {
      var _a2;
      return (_a2 = s.customer_broker_custom_plain_text_rules) != null ? _a2 : [];
    }
  )) == null ? void 0 : _i.length) != null ? _j : 0) > 0;
}
function rerouteNidfToException(props) {
  return Auth.getCurrentUser().managed_indexer && Account.preventNidfToLoadWithCustomerCustomExceptionMessagesEnabled() && selectedLoadHasCustomerCustomExceptionMessages(props);
}
function showAssignLoadsContent(props, state) {
  return (!state.showExceptions || state.showExceptions && activeExceptions(props).length > 0) && !state.recentlyResolved;
}
function assignLoadsHeader(props) {
  var selectedLoad = props.loads.selectedLoad;
  var text = "Assign Load to This Document Group";
  if (selectedLoad && !selectedLoad.load.load_is_auto_confirmed) {
    return /* @__PURE__ */ React.createElement("h3", null, text);
  } else if (!selectedLoad) {
    return /* @__PURE__ */ React.createElement("h3", null, text);
  }
}
function possibleSelectLoadTextNumbering(props) {
  if (props.multiCarrier) {
    return /* @__PURE__ */ React.createElement("strong", null, "1.");
  }
}
function autoConfirmedLoadHeader(props) {
  return /* @__PURE__ */ React.createElement(
    AutoConfirmedLoadHeader,
    {
      carrierInvoice: null,
      load: props.loads.selectedLoad
    }
  );
}
function loadsNotFromEmailCarrier(props, loadState) {
  return props.email.carrier_id && loadState.load.carrier_id !== props.email.carrier_id;
}
function possibleNonMatchingCarrierWarning(props) {
  if (_.find(
    props.loads.guessed,
    (loadState) => loadsNotFromEmailCarrier(props, loadState)
  )) {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--caution" }, /* @__PURE__ */ React.createElement("span", null, "At least one of the following loads is assigned to a", " ", Account.carrierTermLower(), " that does not match the", " ", Account.carrierTermLower(), " assigned to this email."));
  }
}
function carrierChooser(props) {
  if (props.loads.selected && !props.documentBatch.single_carrier) {
    return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__carrier-chooser" }, possibleMultipleGuessedCarriersNotification(props), /* @__PURE__ */ React.createElement("h6", null, /* @__PURE__ */ React.createElement("span", { className: "paragraph__possible-select-load-text-numbering" }, /* @__PURE__ */ React.createElement("strong", null, "2.")), " ", "Select a ", Account.carrierTermLower(), " for this group (optional):"), /* @__PURE__ */ React.createElement(
      CarrierChooser,
      {
        carrierGuesses: props.carrierGuesses(),
        state: props.carrierChooserState,
        allowIndexingCustomerOnlyDocuments: isIndexCustomerOnlyDocsEnabled(
          props
        ),
        onUpdate: props.onCarrierChooserUpdate
      }
    ));
  }
}
function guessedLoadsContent(props, state) {
  if (!state.showSearch) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      LoadTable,
      {
        items: props.loads.guessed,
        highlightChanged: props.highlightReference,
        selectedLoadStateId: props.loads.selected,
        highlightedLoads: _.pluck(props.loads.guessed, "id"),
        loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(props, loadState),
        onSelectionChange: props.setSelectedLoad
      }
    ));
  }
}
function possibleMultipleGuessedCarriersNotification(props) {
  if (props.documentGroup.multiple_guessed_carriers) {
    return /* @__PURE__ */ React.createElement("div", { className: "alert-box--progress" }, "TriumphPay Audit was unable to automatically assign a", " ", Account.carrierTermLower(), " to this group because multiple different", " ", Account.carrierTermLower(), "s or multiple matching", " ", Account.carrierTermLower(), "s with similar names were detected in the documents.");
  }
}
function activeExceptions(props, givenProps) {
  const sourceProps = givenProps ? givenProps : props;
  return _.reject(
    sourceProps.documentGroup.exception_events,
    _.property("resolved_at")
  );
}
function isIndexCustomerOnlyDocsEnabled(props) {
  return Account.currentSettings().allow_indexing_customer_only_documents && props.documentBatch.customer_only;
}
function showInvoiceChooserForCustomerOnlyDocs(props) {
  return props.loads.selected && props.assignCustomerOnlyDocuments && isIndexCustomerOnlyDocsEnabled(props);
}
export default React.createClass({
  mixins: [InvoiceInputFieldsOwnerMixin, History],
  noInvoice: { id: "none" },
  getInitialState: function() {
    const guessedLoad = hasGuessedLoad(this.props);
    return {
      showExceptions: _.first(activeExceptions(this.props)),
      showSearch: !guessedLoad,
      showGuessed: guessedLoad,
      source_invoice_amount: null,
      source_invoice_number: null
    };
  },
  componentDidMount: function() {
    if (hasGuessedLoad(this.props)) {
      this.focusNextField();
    }
  },
  componentWillReceiveProps: function(nextProps) {
    if (this.props.group !== nextProps.group) {
      const guessedLoad = hasGuessedLoad(nextProps);
      this.setState({
        showExceptions: _.first(activeExceptions(this.props, nextProps)),
        showSearch: !guessedLoad,
        showGuessed: guessedLoad
      });
    }
    if (nextProps.saving !== this.props.saving) {
      this.setState({ saving: nextProps.saving });
    }
  },
  assignLoad() {
    var selectedLoadId = this.props.loads.selected;
    this.setState({ saving: true });
    const carrierID = this.props.selectedCarrierID;
    const carrierInvoice = {};
    ["source_invoice_number", "source_invoice_amount"].forEach((field) => {
      if (this.state[field]) {
        carrierInvoice[field] = this.state[field];
      }
    });
    if (hasInvoices(this.props) && this.props.getSelectedInvoiceForGroup(this.noInvoice).id !== this.noInvoice.id) {
      this.props.assignCurrentGroupToLoadAndInvoiceId(
        selectedLoadId,
        this.props.getSelectedInvoiceForGroup(this.noInvoice).id,
        carrierInvoice,
        carrierID,
        false,
        null
      );
      return;
    }
    if (rerouteNidfToException(this.props)) {
      this.props.exceptionCreator("Custom rules found for this customer", false).then(() => {
        if (!this.props.hasMore) {
          console.log("to dashboard with filters");
          ToDashboardWithFilters(this.props.location, this.history);
        } else {
          console.log("documents exception added callback");
          this.props.documentsExceptionAddedCallback();
        }
      });
      return;
    }
    this.props.assignCurrentGroupToLoad(selectedLoadId, carrierID).then(() => this.setState({ saving: false }));
  },
  toggleExceptions: function() {
    this.setState({ showExceptions: !this.state.showExceptions });
  },
  showSearch: function() {
    this.setState({ showSearch: true });
  },
  cancelSearch: function() {
    this.setState({ showSearch: false });
    this.focusNextField();
  },
  carrierSelected: function(carrier) {
    this.setState({ carrier });
  },
  // RENDER
  render: function() {
    return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "TriumphPay Audit \u2013 Assign Loads" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__root", ref: "container" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__scrollable-area" }, this.reportProblemContent(), this.assignLoadsContent()), this.progressArea()));
  },
  assignLoadsContent: function() {
    if (showAssignLoadsContent(this.props, this.state)) {
      return /* @__PURE__ */ React.createElement("div", null, assignLoadsHeader(this.props), this.selectLoadText(), this.documentGroup(), this.possibleExceptionsLink());
    }
  },
  documentGroup: function() {
    return /* @__PURE__ */ React.createElement("div", { className: bem("__group") }, /* @__PURE__ */ React.createElement("div", { className: bem("__group-title") }, this.props.group.name), possibleNonMatchingCarrierWarning(this.props), this.loadSearchArea(), guessedLoadsContent(this.props, this.state));
  },
  possibleExceptionsLink: function() {
    if (!this.state.showExceptions) {
      return /* @__PURE__ */ React.createElement("p", { className: "load-assigner__report-problem" }, "Still issues?", " ", /* @__PURE__ */ React.createElement("a", { onClick: this.toggleExceptions }, "Create an exception"));
    }
  },
  selectLoadText: function() {
    if (!this.state.showSearch) {
      var selectedLoad = this.props.loads.selectedLoad;
      var text = selectedLoad && selectedLoad.load.load_is_auto_confirmed ? autoConfirmedLoadHeader(this.props) : "Select a load from the loads we identified in the documents. ";
      return /* @__PURE__ */ React.createElement("p", { className: "paragraph" }, /* @__PURE__ */ React.createElement("span", null, possibleSelectLoadTextNumbering(this.props), text, "Not the right ones?", " ", /* @__PURE__ */ React.createElement("a", { onClick: this.showSearch }, "Search for another one"), "."));
    }
  },
  progressArea: function() {
    if (this.state.tab !== "exception") {
      return /* @__PURE__ */ React.createElement("div", { className: "load-assigner__save-buttons" }, /* @__PURE__ */ React.createElement("div", { className: "load-assigner__save-buttons-inner" }, this.invoiceInputFields(), carrierChooser(this.props), hasInvoices(this.props) ? this.invoiceChooser() : "", this.messageOrSave()));
    }
  },
  invoiceChooser: function() {
    if (this.props.selectedCarrierID || showInvoiceChooserForCustomerOnlyDocs(this.props)) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        CarrierInvoiceChooser,
        {
          loadID: this.props.loads.selectedLoad.load.load_id,
          invoicesForGroup: this.props.invoicesForGroup,
          initialInvoiceId: _.first(
            _.compact(
              _.pluck(this.props.group.documents, "carrier_invoice_id")
            )
          ),
          selectedInvoice: this.props.getSelectedInvoiceForGroup(
            this.noInvoice
          ),
          carrierID: this.props.selectedCarrierID,
          group: this.props.group,
          noInvoice: this.noInvoice,
          currentlyAssignedInvoice: this.props.currentlyAssignedInvoiceForGroup,
          invoiceSelected: this.props.setSelectedInvoiceForGroup
        }
      ));
    }
  },
  messageOrSave: function() {
    let button;
    if (this.state.saving) {
      button = /* @__PURE__ */ React.createElement("button", { disabled: true }, "Saving...");
    } else if (this.props.loads.selected && this.props.selectedCarrierID) {
      let buttonText = "Continue";
      if (rerouteNidfToException(this.props)) {
        buttonText = "Save as Exception";
      } else if (Account.indexAuditSplitEnabled()) {
        buttonText = "Submit";
      }
      button = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "button--progress ", onClick: this.assignLoad }, buttonText));
    } else if (this.props.loads.selected) {
      button = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "button--progress ", onClick: this.assignLoad }, "Continue without selecting ", Account.carrierTermLower()));
    } else {
      button = /* @__PURE__ */ React.createElement("button", { className: "button--disabled", disabled: true }, "Select a load to continue");
    }
    const progressItems = getLoadAssignerProgressItems(
      this.props.loads.selectedLoad,
      this.props.documentBatch,
      this.props.documentGroup,
      this.invoiceDataEntered(),
      this.props.shipmentDocumentSelections,
      rerouteNidfToException(this.props),
      this.props.documentLoadRelationships
    );
    return /* @__PURE__ */ React.createElement("div", { className: bem("__actions") }, /* @__PURE__ */ React.createElement(LoadAssignerProgress, { content: button, items: progressItems }));
  },
  recentlyResolved: function() {
    this.setState({ recentlyResolved: true });
  },
  closeExceptions: function() {
    this.setState({ recentlyResolved: false, showExceptions: false });
  },
  reportProblemContent: function() {
    if (this.state.showExceptions || !this.state.showExceptions && this.state.recentlyResolved) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "load-assigner__document-exception-area panel",
          ref: "problemContent"
        },
        /* @__PURE__ */ React.createElement(
          DocumentExceptionArea,
          {
            closeExceptions: this.closeExceptions,
            location: this.props.location,
            recentlyResolved: this.recentlyResolved,
            hasMore: this.props.hasMore,
            documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
            model: this.props.model,
            email: this.props.email,
            carrier: this.props.carrier,
            documentGroup: this.props.documentGroup,
            exceptionResolver: this.props.exceptionResolver,
            exceptionCreator: this.props.exceptionCreator,
            exceptionUpdater: this.props.exceptionUpdater,
            exceptions: activeExceptions(this.props),
            scrollUp: this.scrollUp,
            onCancel: this.toggleExceptions
          }
        )
      );
    }
  },
  loadSearchArea: function() {
    if (this.state.showSearch) {
      return /* @__PURE__ */ React.createElement(
        LoadSearchArea,
        {
          loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(this.props, loadState),
          carrier: this.props.carrier,
          selectedLoadStateId: this.props.loads.selected,
          highlightedLoads: _.pluck(this.props.loads.guessed, "id"),
          searcher: this.props.searcher,
          onSelectionChange: this.props.setSelectedLoad,
          onCancel: this.cancelSearch,
          multiCarrier: this.props.multiCarrier,
          highlightReference: this.props.highlightReference
        }
      );
    }
  },
  scrollUp: function() {
    const container = ReactDOM.findDOMNode(this.refs.problemContent);
    container.scrollIntoView();
  }
});
